// import React, { useState, useEffect } from 'react';
// import backgroundImage from "../../assets/bg.png";
// import { Link } from 'react-router-dom';
// import { motion, AnimatePresence } from 'framer-motion';

// const Hero = () => {
//     // State for the typing effect
//     const [displayText, setDisplayText] = useState("");
//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [activeTab, setActiveTab] = useState(0);

//     // Text to be typed
//     const fullText = "Global Business Solutions";

//     // Typing effect
//     useEffect(() => {
//         if (currentIndex < fullText.length) {
//             const timeout = setTimeout(() => {
//                 setDisplayText(prevText => prevText + fullText[currentIndex]);
//                 setCurrentIndex(prevIndex => prevIndex + 1);
//             }, 100);

//             return () => clearTimeout(timeout);
//         }
//     }, [currentIndex, fullText]);

//     // Tabs data
//     const tabs = [
//         {
//             id: 'business',
//             title: 'Import/Export',
//             icon: (
//                 <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
//                 </svg>
//             ),
//             description: 'Expand your business globally with our expert guidance and support.'
//         },
//         {
//             id: 'migration',
//             title: 'Migration Services',
//             icon: (
//                 <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
//                 </svg>
//             ),
//             description: 'Seamless relocation services for individuals and families.'
//         },
//         {
//             id: 'investment',
//             title: 'Business Buy/Sell',
//             icon: (
//                 <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                 </svg>
//             ),
//             description: 'Seamless support for buying or selling businesses with expert evaluation.'
//         }
//     ];

//     return (
//         <div className="relative font-basefont min-h-screen flex flex-col justify-center  -z-10 ">
//             {/* Background with overlay */}
//             <div className="absolute inset-0">
//                 <img
//                     className="h-full w-full object-cover overflow:visible -z-10"
//                     src={backgroundImage}
//                     alt="Global Business Connections"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-br from-basecolor/90 via-basecolor/70 to-black/80" />

//                 {/* Animated patterns */}
//                 <div className="absolute inset-0 opacity-20">
//                     <div className="absolute top-0 left-0 w-full h-full">
//                         {[...Array(20)].map((_, i) => (
//                             <motion.div
//                                 key={i}
//                                 className="absolute rounded-full bg-white"
//                                 style={{
//                                     width: Math.random() * 4 + 1 + "px",
//                                     height: Math.random() * 4 + 1 + "px",
//                                     left: Math.random() * 100 + "%",
//                                     top: Math.random() * 100 + "%",
//                                 }}
//                                 animate={{
//                                     y: [0, -100],
//                                     opacity: [0, 1, 0]
//                                 }}
//                                 transition={{
//                                     duration: Math.random() * 10 + 10,
//                                     repeat: Infinity,
//                                     delay: Math.random() * 5
//                                 }}
//                             />
//                         ))}
//                     </div>
//                 </div>
//             </div>

//             {/* Main content */}
//             <div className="relative   px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full">
//                 <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center pt-20 pb-10">
//                     {/* Left column - Main headline */}
//                     <div className="lg:col-span-7 text-white">
//                         <motion.div
//                             initial={{ opacity: 0, y: 20 }}
//                             animate={{ opacity: 1, y: 0 }}
//                             transition={{ duration: 0.8 }}
//                             className="mb-6"
//                         >
//                             <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">

//                                 Your Gateway to{" "}
//                                 <span className="relative">
//                                     <span className="relative z-10 text-white text-transparent bg-clip-text bg-gradient-to-r from-white to-blue-200">
//                                         {displayText}
//                                     </span>
//                                     <motion.span
//                                         className="absolute bottom-0 left-0 h-3 bg-basecolor"
//                                         initial={{ width: "0%" }}
//                                         animate={{ width: "100%" }}
//                                         transition={{ delay: 2.5, duration: 1 }}
//                                     />
//                                 </span>
//                             </h1>
//                         </motion.div>

//                         <motion.p
//                             initial={{ opacity: 0 }}
//                             animate={{ opacity: 1 }}
//                             transition={{ delay: 0.5, duration: 0.8 }}
//                             className="text-xl text-blue-100 max-w-2xl mb-8"
//                         >
//                             Unlock international opportunities with our expert guidance.
//                             We simplify global expansion for businesses and individuals.
//                         </motion.p>

//                         {/* CTA buttons */}
//                         <motion.div
//                             initial={{ opacity: 0, y: 20 }}
//                             animate={{ opacity: 1, y: 0 }}
//                             transition={{ delay: 0.8, duration: 0.8 }}
//                             className="flex flex-wrap gap-4 mb-12"
//                         >
//                             <Link
//                                 to="#service"
//                                 className="bg-white text-basecolor hover:bg-blue-50 font-bold px-4 py-4 rounded-full 
//                                 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
//                             >
//                                 Explore Services
//                             </Link>
//                             <Link
//                                 to="/contact"
//                                 className="bg-transparent border-2 border-white text-white hover:bg-white/10 
//                                 font-bold px-4 py-4 rounded-full transition-all duration-300"
//                             >
//                                 Contact Us
//                             </Link>
//                         </motion.div>

//                         {/* Stats */}
//                         <motion.div
//                             initial={{ opacity: 0 }}
//                             animate={{ opacity: 1 }}
//                             transition={{ delay: 1.2, duration: 0.8 }}
//                             className="grid grid-cols-3 gap-4 max-w-2xl"
//                         >
//                             {[
//                                 { value: "10+", label: "Years Experience" },
//                                 { value: "50+", label: "Countries Served" },
//                                 { value: "1000+", label: "Satisfied Clients" }
//                             ].map((stat, index) => (
//                                 <div key={index} className="text-center">
//                                     <div className="text-3xl font-bold text-white">{stat.value}</div>
//                                     <div className="text-sm text-blue-100">{stat.label}</div>
//                                 </div>
//                             ))}
//                         </motion.div>
//                     </div>

//                     {/* Right column - Interactive tabs */}
//                     <motion.div
//                         initial={{ opacity: 0, x: 50 }}
//                         animate={{ opacity: 1, x: 0 }}
//                         transition={{ delay: 0.5, duration: 0.8 }}
//                         className="lg:col-span-5"
//                     >
//                         <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-3 lg:p-6 shadow-2xl">
//                             {/* Tabs navigation */}
//                             <div className="flex mb-6 border-b border-white/20">
//                                 {tabs?.map((tab, index) => (
//                                     <button
//                                         key={tab.id}
//                                         onClick={() => setActiveTab(index)}
//                                         className={`flex items-center px-1 lg:px-2 py-3 font-medium text-sm 
//                                             transition-all duration-200 relative ${activeTab === index
//                                                 ? "text-white"
//                                                 : "text-blue-200 hover:text-white"
//                                             }`}
//                                     >
//                                         {/* <span className="mr-2">{tab.icon}</span> */}
//                                         <span>{tab.title}</span>

//                                         {activeTab === index && (
//                                             <motion.div
//                                                 layoutId="activeTab"
//                                                 className="absolute bottom-0 left-0 right-0 h-0.5 bg-white"
//                                                 initial={false}
//                                             />
//                                         )}
//                                     </button>
//                                 ))}
//                             </div>

//                             {/* Tab content */}
//                             <div className="relative overflow-hidden min-h-[200px]">
//                                 <AnimatePresence mode="wait">
//                                     <motion.div
//                                         key={activeTab}
//                                         initial={{ opacity: 0, y: 20 }}
//                                         animate={{ opacity: 1, y: 0 }}
//                                         exit={{ opacity: 0, y: -20 }}
//                                         transition={{ duration: 0.3 }}
//                                         className="text-white"
//                                     >
//                                         <h3 className="text-xl font-bold mb-3">{tabs[activeTab].title}</h3>
//                                         <p className="text-blue-100 mb-6">{tabs[activeTab].description}</p>
//                                         <Link
//                                             to={`/services/${tabs[activeTab].id}`}
//                                             className="inline-flex items-center text-white font-medium hover:text-blue-200 transition-colors"
//                                         >
//                                             Learn more
//                                             <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
//                                             </svg>
//                                         </Link>
//                                     </motion.div>
//                                 </AnimatePresence>
//                             </div>
//                         </div>
//                     </motion.div>
//                 </div>
//             </div>

//             {/* Scroll indicator */}
//             {/* <motion.div
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 transition={{ delay: 2, duration: 1 }}
//                 className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10"
//             >
//                 <motion.div
//                     animate={{ y: [0, 10, 0] }}
//                     transition={{ duration: 1.5, repeat: Infinity }}
//                     className="flex flex-col items-center text-white"
//                 >
//                     <span className="text-sm mb-2">Discover More</span>
//                     <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
//                     </svg>
//                 </motion.div>
//             </motion.div> */}
//         </div>
//     );
// };

// export default Hero;

import React, { useState, useEffect } from 'react';
import backgroundImage from "../../assets/bg.png";
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const Hero = () => {
    const [displayText, setDisplayText] = useState("");
    const [currentIndex, setCurrentIndex] = useState(0);
    const [activeTab, setActiveTab] = useState(0);

    const fullText = "Global Business Solutions";

    useEffect(() => {
        if (currentIndex < fullText.length) {
            const timeout = setTimeout(() => {
                setDisplayText(prevText => prevText + fullText[currentIndex]);
                setCurrentIndex(prevIndex => prevIndex + 1);
            }, 100);

            return () => clearTimeout(timeout);
        }
    }, [currentIndex, fullText]);

    const tabs = [
        {
            id: 'business',
            title: 'Residency by Investment',
            icon: (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                </svg>
            ),
            url: "/services/residency-by-investment",
            description: 'Secure your permanent residency through strategic investment options.'
        },
        {
            id: 'migration',
            title: 'Work Abroad ',
            icon: (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
            ),
            url: "/services/work-abroad",
            description: 'Unlock global career opportunities with comprehensive visa and placement support.'
        },
        {
            id: 'investment',
            title: 'Medical Tourism',
            icon: (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            ),
            url: "/services/medical-tourism-services",
            description: 'Access world-class healthcare at affordable prices.'
        }
    ];

    return (
        <div className="relative font-basefont min-h-screen flex flex-col justify-center overflow-hidden">
            <div className="absolute inset-0 -z-10 overflow-hidden">
                <img
                    className="h-full w-full object-cover"
                    src={backgroundImage}
                    alt="Global Business Connections"
                />
                <div className="absolute inset-0 bg-gradient-to-br from-basecolor/90 via-basecolor/70 to-black/80" />
                <div className="absolute inset-0 opacity-0 z-0 pointer-events-none">
                    <div className="absolute top-0 left-0 w-full h-full">
                        {[...Array(20)].map((_, i) => (
                            <motion.div
                                key={i}
                                className="absolute rounded-full bg-white"
                                style={{
                                    width: Math.random() * 4 + 1 + "px",
                                    height: Math.random() * 4 + 1 + "px",
                                    left: Math.random() * 100 + "%",
                                    top: Math.random() * 100 + "%",
                                }}
                                animate={{
                                    y: [0, -100],
                                    opacity: [0, 1, 0]
                                }}
                                transition={{
                                    duration: Math.random() * 10 + 10,
                                    repeat: Infinity,
                                    delay: Math.random() * 5
                                }}
                            />
                        ))}
                    </div>
                </div>
            </div>

            <div className="relative z-10 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center pt-20 pb-10">
                    <div className="lg:col-span-7 text-white">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8 }}
                            className="mb-6"
                        >
                            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">

                                Your Gateway to{" "}
                                <span className="relative">
                                    <span className="relative z-10 text-white text-transparent bg-clip-text bg-gradient-to-r from-white to-blue-200">
                                        {displayText}
                                    </span>
                                    <motion.span
                                        className="absolute bottom-0 left-0 h-3 bg-basecolor"
                                        initial={{ width: "0%" }}
                                        animate={{ width: "100%" }}
                                        transition={{ delay: 2.5, duration: 1 }}
                                    />
                                </span>
                            </h1>
                        </motion.div>

                        <motion.p
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.5, duration: 0.8 }}
                            className="text-xl text-blue-100 max-w-2xl mb-8"
                        >
                            Unlock international opportunities with our expert guidance.
                            We simplify global expansion for businesses and individuals.
                        </motion.p>

                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.8, duration: 0.8 }}
                            className="flex flex-wrap gap-4 mb-12"
                        >
                            <a
                                href="#service"
                                className="bg-white text-basecolor hover:bg-blue-50 font-bold px-4 py-2 rounded-full 
                                shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
                            >
                                Explore Services
                            </a>
                            <a
                                href="/contact"
                                className="bg-transparent border-2 border-white text-white hover:bg-white/10 
                                font-bold px-4 py-2 rounded-full transition-all duration-300 transform hover:-translate-y-1"
                            >
                                Contact Us
                            </a>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 1.2, duration: 0.8 }}
                            className="grid grid-cols-3 gap-4 max-w-2xl"
                        >
                            {[
                                { value: "10+", label: "Years Experience" },
                                { value: "50+", label: "Countries Served" },
                                { value: "1000+", label: "Satisfied Clients" }
                            ].map((stat, index) => (
                                <div key={index} className="text-center">
                                    <div className="text-3xl font-bold text-white">{stat.value}</div>
                                    <div className="text-sm text-blue-100">{stat.label}</div>
                                </div>
                            ))}
                        </motion.div>
                    </div>

                    <motion.div
                        initial={{ opacity: 0, x: 50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.5, duration: 0.8 }}
                        className="lg:col-span-5"
                    >
                        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-3 lg:p-6 shadow-2xl">
                            {/* Tabs navigation */}
                            <div className="flex mb-6 border-b border-white/20">
                                {tabs?.map((tab, index) => (
                                    <button
                                        key={tab.id}
                                        onClick={() => setActiveTab(index)}
                                        className={`flex items-center px-1 lg:px-2 py-3 font-medium text-sm 
                                            transition-all duration-200 relative ${activeTab === index
                                                ? "text-white"
                                                : "text-blue-200 hover:text-white"
                                            }`}
                                    >
                                        {/* <span className="mr-2">{tab.icon}</span> */}
                                        <span>{tab.title}</span>

                                        {activeTab === index && (
                                            <motion.div
                                                layoutId="activeTab"
                                                className="absolute bottom-0 left-0 right-0 h-0.5 bg-white"
                                                initial={false}
                                            />
                                        )}
                                    </button>
                                ))}
                            </div>

                            {/* Tab content */}
                            <div className="relative overflow-hidden min-h-[200px]">
                                <AnimatePresence mode="wait">
                                    <motion.div
                                        key={activeTab}
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0, y: -20 }}
                                        transition={{ duration: 0.3 }}
                                        className="text-white"
                                    >
                                        <h3 className="text-xl font-bold mb-3">{tabs[activeTab].title}</h3>
                                        <p className="text-blue-100 mb-6">{tabs[activeTab].description}</p>
                                        <Link
                                            to={tabs[activeTab].url}
                                            className="inline-flex items-center text-white font-medium hover:text-blue-200 transition-colors"
                                        >
                                            Learn more
                                            <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                            </svg>
                                        </Link>
                                    </motion.div>
                                </AnimatePresence>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>

        </div>
    );
};

export default Hero;